import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomMonthYearValidator {
  // Validador para datas nos formatos MM/YYYY, DD/MM/YYYY, MM-DD-YYYY e YYYY/MM/DD
  static dateFormatValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { invalidDate: 'Campo obrigatório' }
      };

      // Regex para os formatos aceitos
      const dateRegex =/^(?<m>(0[1-9]|1[0-2]))(|-|\/)(?<y>([0-9]{4}))$/;
      const match = control.value.match(dateRegex);

      if (!match) {return { invalidDate: 'Formato de data inválido' }};

      let month: number, year: number;

      // Verifica qual formato foi utilizado
      if (match.groups?.m && match.groups?.y) {
        month = +match.groups.m;
        year = +match.groups.y;
      } else {
        return { invalidDate: 'Formato de data inválido' };
      }

      // Criar um objeto de data e verificar se é válida
      const dateObj = new Date(year, month - 1, 1);
      if (
        dateObj.getFullYear() !== year ||
        dateObj.getMonth() + 1 !== month
      ) {
        return { invalidDate: 'Data inválida' };
      }

      // Verificar se a data não é maior que o mês/ano atual
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1; // getMonth() retorna 0-11
      
      if (year > currentYear || (year === currentYear && month > currentMonth)) {
        return { invalidDate: 'A data não pode ser maior que o mês/ano atual' };
      }

      return null;
    };
  }
}
